function uncheckAll() {
  var inputs = document.querySelectorAll('.quick-menu-input');

  for (var i = 0; i < inputs.length; i++) {
    inputs[i].checked = false;
  }

}

var arrows = document.querySelectorAll('.icon-left-arrow');
var clicked = false;

for (i = 0; i < arrows.length; i++) {
  var allArrows = arrows[i];

  allArrows.addEventListener('click', function () {
    clicked = true;

    if (clicked === true) {
      //console.log('clicked');
      uncheckAll();

    }
  });
}

